import { PersonalInformation } from "./components/PersonalInformation/PersonalInformation";
import { SignatoryAndShareholding } from "./components/SignatoryAndShareholding/SignatoryAndShareholding";
import { CountryOfResidence } from "./components/CountryOfResidence/CountryOfResidence";
import { PreferredContactInformation } from "./components/PreferredContactInformation/PreferredContactInformation";
import { GA_EVENTS } from "../../utils/ga";

export const TIME_INTERVAL = 5000;
export const FULL_NAME_MAX_LENGTH = 80;
export const STEP_1 = 1;
export const STEP_2 = 2;
export const STEP_3 = 3;
export const STEP_4 = 4;
export const STEP_5 = 5;
export const STEP_6 = 6;

export const positionTypes = [
  {
    code: "government",
    key: "government",
    value: "government",
    label: "Government"
  },
  {
    code: "judicial",
    key: "judicial",
    value: "judicial",
    label: "Judicial"
  },
  {
    code: "military",
    key: "military",
    value: "military",
    label: "Military"
  },
  {
    code: "political",
    key: "political",
    value: "political",
    label: "Political"
  }
];
export const YES_NO_OPTIONS = [
  {
    key: "yes",
    code: "yes",
    displayText: "Yes",
    value: "Yes",
    subGroup: null
  },
  {
    key: "no",
    code: "no",
    displayText: "No",
    value: "No",
    subGroup: null
  }
];

export const stakeHoldersSteps = {
  true: [
    {
      step: STEP_1,
      title: "Personal Information",
      component: PersonalInformation,
      eventName: GA_EVENTS.COMPANY_STAKEHOLDER_PERSONAL_INFORMATION_CONTINUE
    },

    {
      step: STEP_6,
      title: "Preferred contact information",
      component: PreferredContactInformation,
      eventName: GA_EVENTS.COMPANY_STAKEHOLDER_PREFERRED_CONTACT_CONTINUE
    }
  ],
  false: [
    {
      step: STEP_1,
      title: "Personal Information",
      component: PersonalInformation,
      eventName: GA_EVENTS.COMPANY_STAKEHOLDER_PERSONAL_INFORMATION_CONTINUE
    },
    {
      step: STEP_2,
      title: "Signatory Rights",
      component: SignatoryAndShareholding,
      eventName: GA_EVENTS.COMPANY_STAKEHOLDER_SIGNATORY_RIGHTS_CONTINUE
    },
    {
      step: STEP_3,
      title: "Country of residence",
      component: CountryOfResidence,
      eventName: GA_EVENTS.COMPANY_STAKEHOLDER_COUNTRY_OF_RESIDENCE_CONTINUE
    },
    {
      step: STEP_4,
      title: "Preferred contact information",
      component: PreferredContactInformation,
      eventName: GA_EVENTS.COMPANY_STAKEHOLDER_PREFERRED_CONTACT_CONTINUE
    }
  ]
};

export const PRE_ELIGIBILITY_COMPANY_STAKEHOLDER_ID = "pre-eligibility-companyStakeholder_";

export const REFTYPE = true;
export const MAX_COMPANY_NAME_LENGTH = 80;
export const MAX_LICENSE_NUMBER_LENGTH = 20;
export const MAX_REGISTRATION_NUMBER_LENGTH = 15;
export const MAX_REPRESENTED_NAME_LENGTH = 50;
